
import angular from "angular";

/**
 * URl构建器
 */
export class UrlBuilder {

    /**
     * 判断路径是不是带点
     * @param path 
     * @returns 
     */
    private isValidDottedPath(path: string): boolean {
        return (path != null && path !== '' && path !== 'hasOwnProperty' &&
            /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/.test('.' + path));
    }

    /**
     * 在对象中找到相关属性值
     * @param obj 
     * @param path 
     * @returns 
     */
    private lookupDottedPath(obj: any, path: string): any {
        if (!this.isValidDottedPath(path)) {
            throw Error('Dotted member path "@' + path + '" is invalid.');
        }
        var keys = path.split('.');
        for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
            var key = keys[i];
            obj = (obj !== null) ? obj[key] : undefined;
        }
        return obj;
    }

    /**
     * 设置url中的参数
     * @param path url路径
     * @param paramDefaults 配置参数
     * @param data 数据上下文
     * @returns 
     */
    public setUrlParams(path: string, paramDefaults: { [name: string]: string }, data: any): string {

        let url = path;

        if (paramDefaults) {
            for (const key in paramDefaults) {
                if (Object.prototype.hasOwnProperty.call(paramDefaults, key)) {
                    
                    const oringinalValue = paramDefaults[key];

                    let value = oringinalValue && oringinalValue.charAt && oringinalValue.charAt(0) === '@' ? this.lookupDottedPath(data, oringinalValue.substr(1)) : oringinalValue;

                    if (value === undefined || value === null || value === "") {
                        
                        //当数据中没有传参数时，去除URL中的路径参数以及查询参数
                        url = url.replace("/:" + key, "");
                        url = url.replace("[\w]+=:" + key + "[&]?", "");
                    } else {
                        //当数据中有传参数时，设置URL参数
                        if (RegExp(":" + key).test(url)) {
                            //替换path中已有参数
                            url = url.replace(":" + key, value);
                        } else {
                            //增加参数到路径中
                            var myParam = "";

                            if (angular.isArray(value)) {
                                let myParams: Array<string> = [];
                                if (value.length > 0) {
                                    for (let index = 0; index < value.length; index++) {
                                        const element = value[index];
                                        myParams.push(key + "=" + element);
                                    }
                                }

                                myParam = myParams.join("&");
                            } else {
                                myParam = key + "=" + value;
                            }

                            if (url.indexOf("?") > -1) {
                                url = url + "&" + myParam;
                            } else {
                                url = url + "?" + myParam;
                            }
                        }
                    }
                }
            }
        }

        return url;
    }

    /**
     * 将url拼接起来
     * @param rootPath 根路径
     * @param path 资源路径
     * @returns 
     */
    public joinUrl(paths: string[]): string {
        if (paths) {
            if (paths.length > 1) {

                let newPaths: Array<string> = [];
                for (let i = 0; i < paths.length; i++) {
                    let path = paths[i];

                    if (path.indexOf("/") == 0) {
                        path = path.substring(1);
                    }
                    if (path.lastIndexOf("/") == path.length - 1) {
                        path = path.substr(0, path.length - 1);
                    }

                    newPaths.push(path);
                }

                return newPaths.join("/");
            } else {
                return paths.length == 1 ? paths[0] : "";
            }
        }

        return "";
    }

    /**
     * @function commonTool.getUrlParameter
     * @description 获取url参数对象
     */
    public getUrlParameters<T>(): T | null {
        let url = location.search; //获取url中"?"符后的字串

        if (url.indexOf("?") != -1) {
            let lets = url.substr(1).split("&");
            let query_string: any = {}
            for (let i = 0; i < lets.length; i++) {
                let pair = lets[i].split("=");
                let key = decodeURIComponent(pair[0]);
                let value = decodeURIComponent(pair[1]);
                // If first entry with this name
                if (typeof query_string[key] === "undefined") {
                    query_string[key] = decodeURIComponent(value);
                    // If second entry with this name
                } else if (typeof query_string[key] === "string") {
                    let arr = [query_string[key], decodeURIComponent(value)];
                    query_string[key] = arr;
                    // If third or later entry with this name
                } else {
                    query_string[key].push(decodeURIComponent(value));
                }
            }
            return query_string as T;
        }

        return null;
    }

}